import Emojify from "~/components/shared/Emojify";
import { TestPlanProps } from "~/components/analytics/shared/type";
import Icon from "~/components/shared/Icon";

const TestPlan = ({ runName, orchestrationLink, partitions }: TestPlanProps) => (
  <li className="flex flex-col gap-1 border-b border-gray-400 p-2 last:border-b-0">
    <a
      href={orchestrationLink}
      className="text-charcoal-800 w-fit font-medium !no-underline hover:cursor-pointer hover:!underline"
    >
      {runName ? (
        <Emojify text={runName} />
      ) : (
        <div className="flex items-center gap-1">
          <Icon
            icon="heroicons/16/solid/play"
            className="text-gray-600"
            style={{ height: 14, width: 14 }}
          />
          Test Plan
        </div>
      )}
    </a>
    <div className="flex h-5 w-full items-center justify-between rounded-sm bg-purple-300 px-2">
      <span className="flex items-center gap-2 font-mono text-[11px] font-semibold text-white">
        <span className="opacity-60">Min</span>
        {partitions.min}
      </span>
      <span className="flex items-center gap-2 font-mono text-[11px] font-semibold text-white">
        <span className="opacity-60">Max</span>
        {partitions.max}
      </span>
    </div>
    <div className="flex items-center gap-1">
      <div className="flex items-center gap-1">
        <span className="font-mono">{partitions.count}</span>
        <span className="text-gray-800">Partitions</span>
      </div>
    </div>
  </li>
);

export default TestPlan;
